import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialOrgStructureData = {
  completeData: [],
};

const orgStructureSlice = createSlice({
  name: "orgStructureData",
  initialState: initialOrgStructureData,
  reducers: {
    setOrgStructureData: (_state: any, action: PayloadAction<any>) => action.payload,
    addOrgStructureData: (state: any, action: PayloadAction<any>) => {
      state.completeData.unshift(action.payload);
    },
    updateOrgStructureData: (state: any, action: PayloadAction<any>) => {
      state.completeData = state.completeData.map((data: any) =>
        data.id === action.payload.id ? action.payload : data,
      );
    },
    removeOrgStructureData: (state: any, action: PayloadAction<any>) => {
      state.completeData = state.completeData
        .filter((data: any) => !action.payload.includes(data.id))
        .map((data: any) => {
          if (action.payload.includes(data.reportsTo)) {
            return {
              ...data,
              reportsTo: "",
              reportsToName: "",
            };
          }
          return data;
        });
    },
    reorderOrgStructureData: (state: any, action: PayloadAction<any>) => {
      state.completeData = state.completeData.map((data: any) =>
        data.id === action.payload.id ? { ...data, parentId: action.payload.parentId } : data,
      );
    },
  },
});

export const {
  setOrgStructureData,
  addOrgStructureData,
  updateOrgStructureData,
  removeOrgStructureData,
  reorderOrgStructureData,
} = orgStructureSlice.actions;

export const orgStructureData = orgStructureSlice.reducer;

const projectAttachedPositionSlice = createSlice({
  name: "projectAttachedPosition",
  initialState: [],
  reducers: {
    setProjectAttachedPosition: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setProjectAttachedPosition } = projectAttachedPositionSlice.actions;

export const projectAttachedPosition = projectAttachedPositionSlice.reducer;
